(function(){
  function initProductEnhancements(scope){
    var roots = [];
    if (scope && scope.matches && scope.matches('[id^="lbx-product-"]')) {
      roots = [scope];
    } else if (scope && scope.querySelectorAll) {
      roots = Array.prototype.slice.call(scope.querySelectorAll('[id^="lbx-product-"]'));
    } else {
      roots = Array.prototype.slice.call(document.querySelectorAll('[id^="lbx-product-"]'));
    }

    roots.forEach(function(root){
      if (!root || root.dataset.lbxV30Ready === 'true') return;
      root.dataset.lbxV30Ready = 'true';

      setupFinanceCard(root);
      refreshStoreHelp(root);
    });
  }

  function setupFinanceCard(root){
    var card = root.querySelector('[data-lbx-finance-card]');
    var controls = root.querySelector('[data-lbx-finance-controls]');
    var toggle = root.querySelector('[data-lbx-finance-toggle]');
    if (!card || !controls || !toggle) return;

    function applyState(open){
      card.classList.toggle('is-open', !!open);
      controls.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    applyState(false);

    var cleanToggle = toggle.cloneNode(true);
    toggle.parentNode.replaceChild(cleanToggle, toggle);
    cleanToggle.addEventListener('click', function(event){
      event.preventDefault();
      applyState(!card.classList.contains('is-open'));
    });
  }

  function refreshStoreHelp(root){
    var help = root.querySelector('[data-lbx-stock-help]');
    var fastStock = root.querySelector('[data-lbx-fast-stock]');
    if (!fastStock) return;

    var delays = [180, 650, 1400];
    delays.forEach(function(delay){
      window.setTimeout(function(){
        if (!root.isConnected) return;
        if (help && !help.hidden) return;
        var activeButton = root.querySelector('[data-lbx-option-button].is-active');
        var fallbackButton = root.querySelector('[data-lbx-option-button]');
        var trigger = activeButton || fallbackButton;
        if (trigger) trigger.click();
      }, delay);
    });
  }

  function boot(){
    initProductEnhancements(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', function(){
    window.setTimeout(boot, 220);
  });

  document.addEventListener('shopify:section:load', function(event){
    initProductEnhancements(event.target || document);
  });
})();
